// listenerMiddleware.ts
import { createListenerMiddleware } from "@reduxjs/toolkit"
import { camelCase } from "lodash"
import toast from "react-hot-toast"
import { Status } from "../constants/status"
import { WARNING_TOAST_CLASS } from "../constants/toast"
import i18n from "../i18n"
import { sessionFulfilled } from "./slices/session.slice"

export const errorHandler = createListenerMiddleware()

const ERROR_ACTIONS = ["error/showError"]

const recentErrors = new Set<string>()
const ERROR_DEBOUNCE_TIME = 5000 // 5 seconds
const SESSION_EXPIRED_TOAST_DURATION = 8000

errorHandler.startListening({
    predicate: (action) => {
        return action.type?.endsWith("Rejected") || ERROR_ACTIONS.includes(action.type)
    },
    effect: (action, listenerApi) => {
        const message = i18n.t(`status:${camelCase(action.payload)}`)

        if (!recentErrors.has(message)) {
            if (action.payload === Status.UNAUTHORIZED) {
                // not an error of what the user did: a warning, in the middle, until read
                toast(message, {
                    className: WARNING_TOAST_CLASS,
                    position: "bottom-center",
                    duration: SESSION_EXPIRED_TOAST_DURATION,
                })
            } else {
                toast.error(message)
            }
            recentErrors.add(message)

            setTimeout(() => {
                recentErrors.delete(message)
            }, ERROR_DEBOUNCE_TIME)
        }

        if (action.payload === Status.UNAUTHORIZED) {
            listenerApi.dispatch(sessionFulfilled())
        }
    },
})
